module.exports = __webpack_public_path__ + "img/fi-rr-graduation-cap.aa6a14f1.svg";